import React, {useEffect, Fragment, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Link, useLocation} from "react-router-dom";
import {Button, Modal, Dropdown, DropdownButton, NavDropdown} from "react-bootstrap";
import { isPointWithinRadius } from 'geolib';
import Menu from './Menu';
import {
  getRestaurantAction,
  requestWaiterAction,
  divideCheckAction,
  confirmedGetPayChecksAction,
  getMenuAction,
  getPayCheckAction
} from "../../../../store/actions/RestaurantActions";
import {
  approveOrderAction,
  changeOrderCheckoutAction,
  payCheckAction,
  removeOrderDishesAction
} from "../../../../store/actions/OrdersActions";
import swal from "sweetalert";
import Privat from "../../../../images/privat24.svg";
import ApplePay from "../../../../images/ApplePay.svg";
import {ReactComponent as GooglePay} from "../../../../images/GooglePay.svg";
import PlasticCard from "../../../../images/plastic-card.svg";
import NFC from "../../../../images/nfc.svg";
import {ActionCableConsumer} from "react-actioncable-provider";
import QRcodeReader from "../../../common/QRcodeReader";
import {ReactComponent as Delivery} from "../../../../icons/delivery.svg";
import {ReactComponent as WhiteDelivery} from "../../../../icons/delivery-white.svg";
import {ReactComponent as Plate} from "../../../../icons/plate.svg";
import {ReactComponent as WhitePlate} from "../../../../icons/white-plate.svg";
import {ReactComponent as ToGo} from "../../../../icons/to-go.svg";
import {ReactComponent as WhiteToGo} from "../../../../icons/white-to-go.svg";
import {ReactComponent as Snowmobile} from "../../../../icons/snowmobile.svg";
import Select from "react-select";
import {getRestaurantTables, askService} from "../../../../services/RestaurantService";
import {handleError, handleAlert} from "../../../../services/AlertService";
import {Helmet} from "react-helmet";
import { useTranslation } from 'react-i18next';
import {translateRecord, dishes, alreadyPaidPayCheck} from "../../../common/utils";
import ClockWhite from "../../../../icons/clock-white.svg";
import Clock from "../../../../icons/clock.svg";
import Loading from "../../../common/Loading";
import GetLocation from "../../../common/GetLocation";
import {ReactComponent as Money} from "../../../../icons/cash.svg";
import {ReactComponent as MonoPurple} from "../../../../images/monopay_light.svg";
import {payCheckDishes, isTerminal} from "../../../../jsx/common/utils";
import PayCheckDishes from "../../../common/PayCheckDishes";
import {ReactComponent as WiFi} from "../../../../icons/wifi.svg";

const MenuIndex = (props) => {
  const dispatch = useDispatch();
  const store = useSelector(store => store.restaurants);
  const storeOrders = useSelector(store => store.orders);
  const storeAuth = useSelector(store => store.auth);
  const slug = (props.restaurant && props.restaurant.slug) || props.match.params.id;
  const [checkShare, setCheckShare] = useState(false);
  const [disabledWaiterRequest, setDisabledWaiterRequest] = useState(false);
  const [disabledCheckShare, setDisabledCheckShare] = useState(false);
  const [state, setState] = useState({
    checkSharePersons: '',
    dividedPayChecks: [],
    showInitialModal: !storeOrders.order,
    showQRProve: false,
    qrProveFunction: undefined,
    payAlone: false,
    waiterRequestModal: false,
    checkRequestModal: false,
    waiterRequestText: '',
    showTableSelectModal: false,
    selectedService: 0,
    serviceMessage: '',
    tables: {},
    rooms: {},
    selectedTable: {},
    showGetLocation: !!JSON.parse(localStorage.getItem('locationGranted')),
    detectedLocation: {lat: null, lng: null},
    selectedExtraMenu: {},
    showPayCheck: false,
    disablePayCheck: false,
    showInitExtraRests: true
  });
  const tableId = window.location.search.split('?')[1] || props.match.params.table_id;
  const {t} = useTranslation();
  const location = useLocation();
  const {isOperator, selectedOrderType} = location.state || false;

  useEffect(() => {
    if (!(Object.keys(store.restaurants).includes(slug) && Object.keys(store.restaurants[slug]).length > 0) ||
      !store.restaurants[slug].order_types || (!store.restaurants[slug].menu && !store.restaurants[slug].free_delivery)) {
      dispatch(getRestaurantAction(slug, tableId, true)).then((response) => {
        if (!tabData(response.order_types).map(t => t.slug).includes(storeOrders.orderCheckout.selectedOrderType) &&
          !!tabData(response.order_types)[0] && !tableId) {
          dispatch(changeOrderCheckoutAction('selectedOrderType', tabData(response.order_types)[0].slug))
        }
      });
    } else if (!store.restaurants[slug].menu) {
      dispatch(getMenuAction(store.restaurants[slug])).then(() => {
        if (!tabData(store.restaurants[slug].order_types).map(t => t.slug).includes(storeOrders.orderCheckout.selectedOrderType) &&
          !!tabData(store.restaurants[slug].order_types)[0] && !tableId) {
          dispatch(changeOrderCheckoutAction('selectedOrderType', tabData(store.restaurants[slug].order_types)[0].slug))
        }
      });
    } else if (!!store.restaurants[slug].menu && !tableId) {
      if (!tabData(store.restaurants[slug].order_types).map(t => t.slug).includes(storeOrders.orderCheckout.selectedOrderType) &&
        !!tabData(store.restaurants[slug].order_types)[0]) {
        dispatch(changeOrderCheckoutAction('selectedOrderType', tabData(store.restaurants[slug].order_types)[0].slug))
      }
    }
    if (isOperator && !!selectedOrderType) {
      dispatch(changeOrderCheckoutAction('selectedOrderType', selectedOrderType));
    }
    if (!!window.location.search.split('?')[1] &&
      !!window.location.search.split('?')[1].split('&') &&
      window.location.search.split('?')[1].split('&')[1] === 'qr_pay') {
      setState({...state, showPayCheck: true, showInitialModal: false});
      if (!!store.restaurants[slug] && !!store.restaurants[slug].table &&
        (!store.restaurants[slug].table.pay_check || store.restaurants[slug].table.pay_check.amount !== storeOrders.orders[storeOrders.order].table)) {
        dispatch(confirmedGetPayChecksAction(storeOrders.orders[storeOrders.order].table, storeOrders.orders[storeOrders.order].restaurant));
      }
    }
    if (!window.location.pathname.includes(`/menu/${slug}`) && props.history.length <= 2 && !isTerminal) {
      props.history.push(`/menu/${slug}${!!tableId ? '?' + tableId : ''}`)
    }
  }, []);

  useEffect(() => {
    if (!!state.qrProveFunction && !!state.detectedLocation.lat && isPointWithinRadius(
      {latitude: '' + state.detectedLocation.lat, longitude: '' + state.detectedLocation.lng},
      {
        latitude: store.restaurants[slug].latitude,
        longitude: store.restaurants[slug].longitude
      }, 100)) {
      state.qrProveFunction()
    }
  }, [state.detectedLocation]);

  function handleLocationChange({latitude, longitude}) {
    setState({...state, detectedLocation: {lat: latitude, lng: longitude}});
  }

  function requestWaiter(checkRequest, type) {
    setDisabledWaiterRequest(true);
    dispatch(requestWaiterAction(store.restaurants[slug], checkRequest, type,
      !!state.selectedTable.id ? state.selectedTable : null, state.waiterRequestText)).then((resp) => {
      setDisabledWaiterRequest(false);
      setState({
        ...state,
        showQRProve: false,
        showInitialModal: false,
        waiterRequestModal: false,
        checkRequestModal: false,
        showPayCheck: checkRequest && type === 'qr' && !!resp?.pay_check
      })
    });
  }

  function payCheck(payCheck) {
    dispatch(payCheckAction(store.restaurants[slug], payCheck, props.history));
  }

  function setDivision(persons) {
    if (persons > 0 && persons < 10) {
      let dividedPayChecks = [];
      [...Array(parseInt(persons))].map((_, i) =>
        dividedPayChecks.push({amount: !!state.dividedPayChecks[i] ? state.dividedPayChecks[i].amount : ''})
      );
      setState({
        ...state,
        checkSharePersons: persons,
        dividedPayChecks: dividedPayChecks
      })
    } else {
      setState({
        ...state,
        checkSharePersons: '',
        dividedPayChecks: []
      });
    }
  }

  function setPersonCheckAmount(index, amount) {
    let payChecks = [...state.dividedPayChecks];
    payChecks[index] = {...payChecks[index], amount: amount};
    if (amount < 0) {
      handleError([t('errors.biggerZero')]);
    } else if (calculateAmount(payChecks) > calculateAmount(tablePayChecks(store.restaurants[slug].table))) {
      handleError([t('errors.biggerSum')]);
    } else {
      setState({...state, dividedPayChecks: payChecks})
    }
  }

  function calculateAmount(array) {
    return array.reduce((partialSum, a) => partialSum + (!!a.amount ? parseFloat(a.amount) : 0), 0)
  }

  function divideCheck() {
    setDisabledCheckShare(true);
    dispatch(divideCheckAction(state.dividedPayChecks, store.restaurants[slug])).then(() => {
      setDisabledCheckShare(false);
      setCheckShare(false);
      setState({...state, payAlone: false});
    });
  }

  function tabData(order_types) {
    return Object.keys(order_types).filter(o => o !== 'on_table')
      .filter((order_type) => Object.values(order_types[order_type])
        .includes(true)).sort((a, b) => b.localeCompare(a)).map((order_type) => {
          return {
            name: t(`orderTypes.${order_type}.name`),
            slug: order_type,
            description: t(`orderTypes.${order_type}.description`)
          }
        }
      );
  }

  function updateTable(data) {
    dispatch(confirmedGetPayChecksAction(data.table, store.restaurants[slug]));
  }

  function tablePayChecks(table) {
    const childPayChecks = !!table.pay_check && table.pay_check.child_pay_checks;
    if (!!childPayChecks && childPayChecks.length > 0 && !state.payAlone) {
      return table.pay_check.child_pay_checks.sort((a, b) => a.id - b.id);
    } else {
      return !!table.pay_check ? [table.pay_check].filter((c) => c.status === 'approved') : [];
    }
  }

  function canBeDivided() {
    if (!!store.restaurants[slug].poster_id) {
      return false;
    } else if (!!store.restaurants[slug].table.pay_check && store.restaurants[slug].table.pay_check.child_pay_checks.length > 0) {
      return !store.restaurants[slug].table.pay_check.child_pay_checks.some((p) => p.status === 'paid') &&
             !store.restaurants[slug].table.pay_check.child_pay_checks.some((p) => !!p.poster_id)
    } else {
      return true;
    }
  }

  function toggleQRprove(func) {
    if (process.env.REACT_APP_ENV === 'development' || storeOrders.approveOrder ||
        (!!state.detectedLocation.lat && isPointWithinRadius(
      { latitude: ''+state.detectedLocation.lat, longitude: ''+state.detectedLocation.lng },
      { latitude: store.restaurants[slug].latitude, longitude: store.restaurants[slug].longitude }, 100))) {
      func()
    } else {
      setState({...state, selectedService: 0, waiterRequestModal: false, showQRProve: true, showInitialModal: true,
        qrProveFunction: func, checkRequestModal: false})
    }
  }

  function working_time(restaurant) {
    let result = '';
    if (restaurant.working_hours.default) {
      if (restaurant.working_hours.default.always_open) {
        return t('alwaysOpen');
      } else {
        result = `${getTime(restaurant.working_hours.default.working_hours[new Date().toLocaleString('en-us', {weekday: 'short'})].start_time)} - ${getTime(restaurant.working_hours.default.working_hours[new Date().toLocaleString('en-us', {weekday: 'short'})].end_time)}`
      }
    } else {
      result = `${getTime(restaurant.working_hours.working_hours[new Date().toLocaleString('en-us', {weekday: 'short'})].start_time)} - ${getTime(restaurant.working_hours.working_hours[new Date().toLocaleString('en-us', {weekday: 'short'})].end_time)}`
    }
    return result;
  }

  function getTime(time) {
    return time.split(' ')[1];
  }

  function orderTypeIcon() {
    if (storeOrders.orderCheckout.selectedOrderType === 'to_visit' || storeOrders.orderCheckout.selectedOrderType === 'on_table') {
      return !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? <WhitePlate className='mr-2'/> :
        <Plate className='mr-2'/>;
    } else if (storeOrders.orderCheckout.selectedOrderType === 'to_go') {
      return !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? <WhiteToGo className='mr-2'/> :
        <ToGo className='mr-2'/>;
    } else {
      if (store.restaurants[slug].id === 166) {
        return <Snowmobile
          fill={!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : 'black'}
          className='mr-2' width={30} height={30}/>;
      } else {
        return !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ?
          <WhiteDelivery className='mr-2'/> : <Delivery className='mr-2'/>;
      }
    }
  }

  function getTables() {
    getRestaurantTables(store.restaurants[slug]).then((response) => {
      setState({...state, showTableSelectModal: true, tables: response.data.tables, rooms: response.data.rooms})
    })
  }

  function requestService() {
    askService(slug, state.selectedService, tableId, state.serviceMessage).then(() => {
      setState({...state, selectedService: 0, serviceMessage: ''});
      handleAlert('success', 'Gotovo', 'Послугу замовлено')
    }).catch((error) => handleError(error.response.data.errors, error.response));
  }

  function setTable(table) {
    setState({
      ...state,
      showTableSelectModal: false,
      selectedTable: {
        ...state.selectedTable,
        id: table.value,
        value: table.value,
        label: table.label,
        name: table.name
      }
    })
  }

  function grantGeoLocation() {
    localStorage.setItem('locationGranted', 'true');
    setState({...state, showGetLocation: true});
  }

  function approveOrder(field, value) {
    dispatch(approveOrderAction());
    setState({...state, [field]: value});
  }

  function getExtraMenu(r) {
    if (!!store.restaurants[r.slug] && !!store.restaurants[r.slug].menu) {
      setState({...state, selectedExtraMenu: r, showInitialModal: false, showQRProve: false, showInitExtraRests: false})
    } else {
      dispatch(getRestaurantAction(r.slug, null, true)).then(() =>
        setState({...state, selectedExtraMenu: r, showInitialModal: false, showQRProve: false, showInitExtraRests: false})
      )
    }
  }

  function hasSplitedTableOrder() {
    let result = 0;
    if (!!storeOrders.orderDishes[slug] && Object.keys(storeOrders.orderDishes[slug].dishes).length > 0) {
      result += 1;
    }
    if (!!store.restaurants[slug].table) {
      !!store.restaurants[slug].extra_menus && store.restaurants[slug].extra_menus.map((m) => {
        if (!!storeOrders.orderDishes[m.slug] && Object.keys(storeOrders.orderDishes[m.slug].dishes).length > 0) {
          result += 1;
        }
      });
    }
    return result > 1;
  }

  function selectedDishesCount(slug) {
    if (storeOrders.orderDishes[slug]) {
      return Object.keys(storeOrders.orderDishes[slug].dishes).length;
    } else {
      return 0;
    }
  }

  function payCheckAmount() {
    if (store.restaurants[slug].table.pay_check.child_pay_checks.length > 0) {
      return store.restaurants[slug].table.pay_check.child_pay_checks.filter((pc) => !alreadyPaidPayCheck(pc)).reduce((partialSum, a) => partialSum + parseFloat(a.amount), 0);
    } else {
      return parseFloat(store.restaurants[slug].table.pay_check.amount);
    }
  }

  function payBillFunction() {
    if (!!store.restaurants[slug].table.pay_check) {
      if (store.restaurants[slug].table.pay_check.child_pay_checks.length > 0 ||
          store.restaurants[slug].table.room.ask_after_pay_method) {
        return setState({...state, showPayCheck: true, showInitialModal: false});
      } else {
        return setState({...state, checkRequestModal: true, showInitialModal: false});
      }
    } else {
      return toggleQRprove(() => approveOrder('checkRequestModal', true));
    }
  }

  function getPaycheck() {
    if (!!store.restaurants[slug].poster_id) {
      setState({...state, disablePayCheck: true});
      dispatch(getPayCheckAction(store.restaurants[slug])).then(() => setState({...state, disablePayCheck: false}))
    }
  }

  function handeTableOrderTypeChange(orderType) {
    if (hasSplitedTableOrder() && orderType !== 'on_table') {
      handleError([t('errors.onlyOnTableOrder')])
    } else {
      dispatch(changeOrderCheckoutAction('selectedOrderType', orderType))
    }
  }

  function hasQRorders() {
    return Object.values(store.restaurants[slug].order_types.on_table).includes(true);
  }

  console.log('store', store)
  // console.log('state', state)
  // console.log('storeOrdersIndex', storeOrders)
  // console.log('isOperator', isOperator)
  // console.log('selectedOrderType', selectedOrderType)

  return (
    <div className='custom-tab-1 mb-4'>
      { !!store.restaurants[slug] && !!store.restaurants[slug].table &&
        <ActionCableConsumer channel={{channel: 'TableChannel', room: store.restaurants[slug].table.id}}
          onReceived={(data) => updateTable(data)}
        />}
      { !!store.restaurants[slug] && !!store.restaurants[slug].order_types &&
        <Helmet>
          <title>
            { translateRecord(store.restaurants[slug], 'name')} | {t('menu')} {!!store.restaurants[slug].table ?
              `| ${store.restaurants[slug].table.name}` : ''}
          </title>
        </Helmet>}
      { !store.restaurants[slug]?.table?.is_terminal &&
        <>
          { !!tableId && !!store.restaurants[slug] && store.restaurants[slug].allow_extra_menus &&
              !!store.restaurants[slug].extra_menus && store.restaurants[slug].extra_menus.length > 0 &&
            <div className='d-flex orders active-orders-tabs mb-2'>
              <div className={`order-dish ml-1 extra-menu active-order ${!state.selectedExtraMenu.id && 'selected-menu'}`}
                   style={{boxShadow: '0px 3px 10px 0px rgba(29, 10, 3, 0.08)'}}
                   onClick={() => setState({...state, selectedExtraMenu: {}})}
              >
                { !!store.restaurants[slug].logo ?
                  <>
                    <img src={store.restaurants[slug].logo} style={{height: 40, filter: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? "invert(100%) brightness(1000%)" : ''}}/>
                    <p className='text-black fs-14 mb-0 mt-2'>{translateRecord(store.restaurants[slug], 'extra_description')}</p>
                    <p className='fs-14 mb-0' style={{color: '#FC9564'}}>
                      <i className='fa fa-clock-o mr-1'/>
                      {working_time(store.restaurants[slug])}
                    </p>
                  </>
                :
                  <>
                    <h4 className='mb-0'>{translateRecord(store.restaurants[slug], 'name')}</h4>
                    <p className='text-black fs-14 mb-0'>{translateRecord(store.restaurants[slug], 'extra_description')}</p>
                    { selectedDishesCount(slug) > 0 &&
                      <span className='selected-dishes fs-16' onClick={() => dispatch(removeOrderDishesAction(slug))}
                            style={{cursor: 'pointer'}}
                      >
                        {selectedDishesCount(slug)}
                        <span className='text-black fs-12' style={{position: 'absolute', right: 0, top: -6}}>
                          &times;
                        </span>
                      </span>}
                    <p className='fs-14 mb-0' style={{color: '#FC9564'}}>
                      <i className='fa fa-clock-o mr-1'/>
                      {working_time(store.restaurants[slug])}
                    </p>
                  </>}
              </div>
              { store.restaurants[slug].extra_menus.map((r, i) =>
                <div key={i} className={`order-dish ml-1 extra-menu active-order 
                        ${''+state.selectedExtraMenu.id === ''+r.id && 'selected-menu'}`}
                     style={{boxShadow: '0px 3px 10px 0px rgba(29, 10, 3, 0.08)'}}
                     onClick={() => getExtraMenu(r)}
                >
                  { !!r.logo ?
                    <>
                      <img src={r.logo} style={{height: 40, filter: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? "invert(100%) brightness(1000%)" : ''}}/>
                      <p className='text-black fs-14 mb-0 mt-2'>{translateRecord(r, 'extra_description')}</p>
                      <p className='fs-14 mb-0' style={{color: '#FC9564'}}>
                        <i className='fa fa-clock-o mr-1'/>
                        {working_time(r)}
                      </p>
                    </>
                  :
                    <>
                      <h4 className='mb-0'>{translateRecord(r, 'name')}</h4>
                      <p className='text-black fs-14 mb-0'>{translateRecord(r, 'extra_description')}</p>
                      { selectedDishesCount(r.slug) > 0 &&
                        <span className='selected-dishes fs-16' onClick={() => dispatch(removeOrderDishesAction(r.slug))}
                              style={{cursor: 'pointer'}}
                        >
                          {selectedDishesCount(r.slug)}
                          <span className='text-black fs-12' style={{position: 'absolute', right: 0, top: -6}}>
                            &times;
                          </span>
                        </span>}
                      <p className='fs-14 mb-0' style={{color: '#FC9564'}}>
                        <i className='fa fa-clock-o mr-1'/>
                        {working_time(r)}
                      </p>
                    </>}
                </div>)}
            </div>}
          { !!store.restaurants[slug] && !!store.restaurants[slug].order_types &&
            <div className='card'
            //     style={{background: 'url(https://ecooboi.com.ua/files/cache/24/3b/1f/ecooboi-ukrainskaya-vishivanka-gorizontalno-10428.jpg)'}}
            >
              <div className='card-body'>
                <div>
                  { (!tableId || (!!store.restaurants[slug] && !(store.restaurants[slug].allow_extra_menus &&
                      !!store.restaurants[slug].extra_menus && store.restaurants[slug].extra_menus.length > 0))) &&
                    <div className='d-flex mb-3' style={{alignItems: "center", justifyContent: "space-between"}}>
                      <Link to={`/r/${slug}`} className='mr-2'>
                        { !!store.restaurants[slug].logo ?
                          <img className='mb-1' src={store.restaurants[slug].logo} style={{height: 40, filter: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? "invert(100%) brightness(1000%)" : ''}}/>
                        :
                          <h3 className='mb-0'>{translateRecord(store.restaurants[slug], 'name')}</h3>}
                      </Link>
                      <h4 style={{color: '#FC9564', minWidth: 'max-content'}} className='mb-0'>
                        <i className='fa fa-clock-o mr-1'/>
                        {working_time(store.restaurants[slug])}
                      </h4>
                    </div>}
                </div>
                { !store.restaurants[slug].working_hours.default.always_open && store.restaurants[slug].working_hours.default.
                  working_hours[new Date().toLocaleString('en-us', {weekday: 'short'})].holiday &&
                    <h4 className='mb-3' style={{color: "#bb1e57", textAlign: 'center', display: "block"}}>
                      {t('components.home.holiday')}
                    </h4>}
                { !!store.restaurants[slug] && !!store.restaurants[slug].order_types && !store.restaurants[slug].table &&
                  <>
                    { tabData(store.restaurants[slug].order_types).length > 0 &&
                      <div>
                        <div className='d-flex align-items-center justify-content-around order-types'>
                          { tabData(store.restaurants[slug].order_types).map((data, i) =>
                            <div onClick={() => dispatch(changeOrderCheckoutAction('selectedOrderType', data.slug))} key={i}
                              className={`${storeOrders.orderCheckout.selectedOrderType === data.slug && 'btn-primary w-100'} order-type`}
                            >
                              <h6 className='mb-0' style={{color: storeOrders.orderCheckout.selectedOrderType === data.slug && 'white'}}>
                                {t(`orderTypes.${data.slug}.name`)}
                              </h6>
                            </div>)}
                        </div>
                        <div className='pt-3 pb-1 text-center text-black'>
                          <div className='d-flex align-items-center justify-content-center'>
                            {orderTypeIcon()}
                            <span>{t(`orderTypes.${storeOrders.orderCheckout.selectedOrderType}.description`)}</span>
                          </div>
                          { !!store.restaurants[slug].free_delivery && storeOrders.orderCheckout.selectedOrderType === 'delivery' &&
                            <div className='mt-2'>
                              { !!storeOrders.orderCheckout.delivery_point.lat ?
                                <>
                                  { !!storeOrders.orderCheckout.prices && !!storeOrders.orderCheckout.prices[0] &&
                                    !!storeOrders.orderCheckout.prices[0].free_from &&
                                    <Button className='btn btn-xxs btn-primary'>
                                      {t('freeDeliveryFrom')} {t('from').toLowerCase()} {storeOrders.orderCheckout.prices[0].free_from}<small>₴</small>
                                    </Button>}
                                </>
                              :
                                <Button className='btn btn-xxs btn-primary'>
                                  {t('freeDeliveryFrom')} {t('from').toLowerCase()} {store.restaurants[slug].free_delivery.free_delivery_from}<small>₴</small>
                                </Button>}
                            </div>}
                          { !!store.restaurants[slug].order_types[storeOrders.orderCheckout.selectedOrderType].min_order &&
                            <Button className='btn btn-xxs btn-outline-primary mt-2'>
                              {t('components.menu.minOrderFrom')} {store.restaurants[slug].order_types[storeOrders.orderCheckout.selectedOrderType].min_order}<small>₴</small>
                            </Button>}
                        </div>
                        { !!store.restaurants[slug] && !!store.restaurants[slug].table &&
                          <div className='pt-2 pb-2 text-center text-black'>
                            {t('orderTypes.on_table.description')}
                          </div>}
                        { !store.restaurants[slug].working_hours[storeOrders.orderCheckout.selectedOrderType].default &&
                          <div className='d-flex align-items-center justify-content-center mt-2'>
                            { !!store.restaurants[slug].working_hours[storeOrders.orderCheckout.selectedOrderType].working_hours[new Date().toLocaleString('en-us', {weekday:'short'})].holiday ?
                              <h6 className='mb-0' style={{color: "#bb1e57"}}>{t('components.home.holiday')}</h6>
                            :
                              <>
                                { !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ?
                                  <img src={ClockWhite} style={{height: 19}} className='mr-1'/>
                                :
                                  <img src={Clock} style={{height: 19}} className='mr-1'/>}
                                <p className='mb-0 text-black'>
                                  {`${getTime(store.restaurants[slug].working_hours[storeOrders.orderCheckout.selectedOrderType].working_hours[new Date().toLocaleString('en-us', {weekday:'short'})].start_time)} - ${getTime(store.restaurants[slug].working_hours[storeOrders.orderCheckout.selectedOrderType].working_hours[new Date().toLocaleString('en-us', {weekday:'short'})].end_time)}`}
                                </p>
                              </>}
                          </div>}
                      </div>}
                  </>}
                {!!store.restaurants[slug] && !!store.restaurants[slug].table &&
                  <>
                    { hasQRorders() &&
                      <>
                        { store.restaurants[slug].table.room.ask_after_pay_method &&
                          store.restaurants[slug].table.room.allow_other_orders &&
                          <div className='d-flex align-items-center justify-content-around order-types mb-3'>
                            { ['on_table', 'to_visit', 'to_go'].map((order_type, i) =>
                              <Fragment key={i}>
                                <div onClick={() => handeTableOrderTypeChange(order_type)}
                                  className={`${storeOrders.orderCheckout.selectedOrderType === order_type && 'btn-primary w-100'} order-type`}
                                >
                                  <h6 className='mb-0' style={{color: storeOrders.orderCheckout.selectedOrderType === order_type && 'white'}}>
                                    {t(`after_pay_methods.${order_type}.name`)}
                                  </h6>
                                </div>
                              </Fragment>)}
                          </div>}
                        { store.restaurants[slug].table.room.ask_after_pay_method &&
                            store.restaurants[slug].table.room.allow_other_orders ?
                          <div className='text-center text-black'>
                            {orderTypeIcon()}
                            <span>{t(`after_pay_methods.${storeOrders.orderCheckout.selectedOrderType}.description`)}</span>
                          </div>
                        :
                          <div className='d-flex align-items-center justify-content-center text-black'>
                            {orderTypeIcon()}
                            <b>{t('orderTypes.on_table.description')}</b>
                          </div>}
                      </>}
                    <h5 className='text-center text-black mt-1' onClick={!!storeAuth.auth.restaurant &&
                          store.restaurants[slug].id === storeAuth.auth.restaurant.id ? getTables : null}
                    >
                      <span>{state.selectedTable.name || store.restaurants[slug].table.name}</span>
                    </h5>
                    <Button className='btn-secondary w-100 position-relative'
                            onClick={() => setState({...state, showInitialModal: true, showInitExtraRests: false})}
                    >
                      <b>
                        {store.restaurants[slug].table.room.allow_waiter_request ? t('components.menu.requestWaiter') : t('components.menu.reviews')}
                        {(!store.restaurants[slug].table.room.ask_after_pay_method || !!store.restaurants[slug].table.pay_check) && <>, {t('components.menu.pay').toLowerCase()}</>}
                        {store.restaurants[slug].tips_url && <>, {t('components.menu.tips').toLowerCase()}</>}...
                      </b>
                      { !!store.restaurants[slug].table.pay_check &&
                        <h6 className='unpaid-paychecks text-white' style={{top: -14}}>
                          <small>{t('components.menu.bill')}</small> {payCheckAmount().toFixed(2)}<small>₴</small>
                        </h6>}
                    </Button>
                  </>}
              </div>
            </div>}
        </>}
      { !(store.restaurants[slug] && store.restaurants[slug].menu) && <Loading/>}
      { !!store.restaurants[slug] && !!store.restaurants[slug].menu &&
        <Menu restaurant={store.restaurants[slug]} selectedExtraMenu={state.selectedExtraMenu} isOperator={isOperator}
              passedFunction={props.passedFunction} tableId={tableId} hasSplitedTableOrder={hasSplitedTableOrder}
              table={!!state.selectedTable.id ? state.selectedTable : store.restaurants[slug].table}
              history={props.history} acceptOutsideOrders={tabData(store.restaurants[slug].order_types).length > 0}
              handeTableOrderTypeChange={handeTableOrderTypeChange}
        />}

      {/*Waiter request modal*/}

      { !!store.restaurants[slug] && !!store.restaurants[slug].table &&
        <Modal className="fade" show={state.waiterRequestModal}>
          <Modal.Header>
            <Modal.Title className='text-black'>{t('components.menu.requestWaiter')}</Modal.Title>
            <Button variant="" className="close" onClick={() => setState({...state, waiterRequestModal: false})}>
              <span>&times;</span>
            </Button>
          </Modal.Header>
          <Modal.Body>
            <h4 className='text-center'>{t('components.menu.orderWithoutWaiter')}</h4>
            { !store.restaurants[slug].table.room.ask_after_pay_method &&
              <Button className='btn-sm btn-warning w-100 mt-4'
                      onClick={() => setState({...state, checkRequestModal: true})}
              >
                {t('components.menu.wantToPay')}
              </Button>}
            <label className='mt-4'>{t('components.menu.messageWaiter')}</label>
            <textarea rows={4} value={state.waiterRequestText} className='form-control'
                      placeholder={t('components.menu.placeholderWaiter')}
                      onChange={(e) => setState({...state, waiterRequestText: e.target.value})}/>
          </Modal.Body>
          <Modal.Footer>
            <Button className='btn-lg btn-info w-100' onClick={() => requestWaiter()} disabled={disabledWaiterRequest}>
              {t('components.menu.makeWaiterRequest')}
            </Button>
          </Modal.Footer>
        </Modal>}

      {/*Check request modal*/}

      { !!store.restaurants[slug] && state.checkRequestModal &&
        <Modal className="fade" show={state.checkRequestModal} onEntered={getPaycheck}>
          <Modal.Header>
            <Modal.Title className='text-black'>{t('components.menu.howToPay')}</Modal.Title>
            <Button variant="" className="close" onClick={() => setState({...state, checkRequestModal: false})}>
              <span>&times;</span>
            </Button>
          </Modal.Header>
          <Modal.Body>
            { !!store.restaurants[slug] && store.restaurants[slug].qr_pay &&
              <Button className='btn btn-success w-100 mb-3' disabled={disabledWaiterRequest}
                      onClick={() => !!store.restaurants[slug].table.pay_check ?
                        setState({...state, showPayCheck: true, checkRequestModal: false, showInitialModal: false})
                      :
                        requestWaiter(true, 'qr')}
                //onClick={getPaycheck}
              >
                <h4 className='text-full-black mb-0'>
                  {t('components.checkout.pre_pay')} {!!store.restaurants[slug].table.pay_check && <>{store.restaurants[slug].table.pay_check.amount}<small>₴</small></>}
                </h4>
                { !!store.restaurants[slug].table.pay_check &&
                    store.restaurants[slug].table.pay_check.status === 'created' &&
                  <p className='mb-0' style={{color: '#b53535'}}>
                    <small>Сума включає лише замовлення зроблені через QR код</small>
                  </p>}
                <img src={ApplePay} style={{width: '70px'}}/>
                <GooglePay fill='white' style={{width: '70px', height: '30px'}}/>
                { store.restaurants[slug].payment_provider === 'monobank' ?
                  <MonoPurple style={{height: 30, width: 80}}/>
                :
                  <img src={Privat} style={{width: '45px'}}/>}
                <span className='d-block'>{t('components.menu.possibleToShare')}</span>
              </Button>}
            <Button className='btn btn-warning w-100 mb-3' disabled={disabledWaiterRequest}
                    onClick={() => requestWaiter(true, 'cash')}
            >
              <h4 className='text-full-black'>{t('components.menu.byCash')}</h4>
              <Money stroke='#2F2D2A' width={70} height={70}/>
            </Button>
            { !!store.restaurants[slug] && store.restaurants[slug].terminal &&
              <Button className='btn btn-info w-100' disabled={disabledWaiterRequest}
                      onClick={() => requestWaiter(true, 'terminal')}
              >
                <h4 className='text-full-black'>{t('components.menu.byTerminal')}</h4>
                <img className='mr-4' src={PlasticCard} style={{width: '70px'}}/>
                <img src={NFC} style={{width: '35px'}}/>
              </Button>}
            { Object.keys(payCheckDishes(store.restaurants[slug].table.pay_check)).length > 0 &&
              <div className='mt-4'>
                <h4>{t('components.menu.yourOrder')}</h4>
                <PayCheckDishes table={store.restaurants[slug].table}
                                payCheck={store.restaurants[slug].table.pay_check}/>
              </div>}
          </Modal.Body>
        </Modal>}

      {/*/!*Check pay modal*!/*/}

      {!!store.restaurants[slug] && !!store.restaurants[slug].table && !!store.restaurants[slug].table.pay_check &&
        <Modal className="fade" show={state.showPayCheck} onEntered={getPaycheck}>
          <Modal.Header style={{justifyContent: 'center'}}>
            <Modal.Title>
              <h3 className='text-black mb-0'>{t('components.menu.payBill')}</h3>
              { !!store.restaurants[slug].table.pay_check &&
                <h4 className='mb-0 text-center'>
                  {store.restaurants[slug].table.pay_check.amount}<small>₴</small>
                </h4>}
            </Modal.Title>
            <Button variant="" className="close" onClick={() => setState({...state, showPayCheck: false})}>
              <span>&times;</span>
            </Button>
          </Modal.Header>
          <Modal.Body>
            { !!store.restaurants[slug].tips_url &&
              <a href={store.restaurants[slug].tips_url} target='_blank' className='btn btn-outline-primary w-100 mb-4'>
                {t('components.menu.leaveTips')}
              </a>}
            { !checkShare ?
              <>
                { tablePayChecks(store.restaurants[slug].table).map((pay_check, i) =>
                  <Fragment key={i}>
                    { store.restaurants[slug].table.pay_check.child_pay_checks.length > 1 &&
                      <>
                        { !!pay_check.user ?
                          <h5 className='text-center'>{pay_check.user.name}{!!pay_check.invoice_url && ` - ${alreadyPaidPayCheck(pay_check) ? t('orderStatuses.payed') : t('components.menu.inPayProcess')}`}</h5>
                        :
                          <h5 className='text-center'>{t('components.menu.person')} {i+1} {alreadyPaidPayCheck(pay_check) && `- ${t('orderStatuses.payed')}`}</h5>}
                      </>}
                    <Button className='btn btn-success w-100 mb-2'
                      disabled={state.disablePayCheck || alreadyPaidPayCheck(pay_check)}
                      onClick={() => {
                        if (!!pay_check.invoice_url && (pay_check.user.uid !== storeAuth.auth.uid)) {
                          swal({
                            title: t('components.menu.wishToPay'),
                            text: `${pay_check.user.name} ${t('components.menu.alreadyPaying')}`,
                            icon: "warning",
                            buttons: {
                              cancel: {
                                text: t('no'),
                                visible: true
                              },
                              confirm: {
                                text: t('yes'),
                                visible: true
                              },
                            },
                            dangerMode: true,
                          }).then((ok) => {if (ok) {payCheck(pay_check)}})
                        } else {
                          payCheck(pay_check)
                        }
                      }}
                    >
                      <h4 className='text-full-black mb-0'>
                        {t('pay')} {pay_check.amount}<small>₴</small>
                      </h4>
                      { !!store.restaurants[slug].table.pay_check &&
                          store.restaurants[slug].table.pay_check.status === 'created' &&
                        <p className='mb-0' style={{color: '#b53535'}}>
                          <small>Сума включає лише замовлення зроблені через QR код</small>
                        </p>}
                      <img src={ApplePay} style={{width: '70px'}}/>
                      <GooglePay fill='white' style={{width: '70px', height: '30px'}}/>
                      { store.restaurants[slug].payment_provider === 'monobank' ?
                        <MonoPurple style={{height: 30, width: 80}}/>
                      :
                        <img src={Privat} style={{width: '45px'}}/>}
                    </Button>
                  </Fragment>)}
                { canBeDivided() &&
                  <>
                    <h4 className='text-center mb-0'>{t('or')}</h4>
                    <Button className='btn btn-warning w-100 mt-2' onClick={() => setCheckShare(true)}>
                      <h4 className='text-full-black mb-0'>
                        { !!store.restaurants[slug].table.pay_check &&
                            store.restaurants[slug].table.pay_check.child_pay_checks.length > 1 ?
                          t('components.menu.changePersons') : t('components.menu.divideBill')}
                      </h4>
                    </Button>
                  </>}
                { (Object.keys(payCheckDishes(store.restaurants[slug].table.pay_check)).length > 0 ||
                    store.restaurants[slug].table.pay_check.child_pay_checks.length > 0) &&
                  <div className='mt-3'>
                    <h4>{t('components.menu.yourOrder')}</h4>
                    <PayCheckDishes table={store.restaurants[slug].table}
                                    payCheck={store.restaurants[slug].table.pay_check}/>
                  </div>}
              </>
            :
              <>
                <h4 className='text-black text-center mb-3'>{t('components.menu.dividingBill')}</h4>
                <div className='input-group'>
                  <div className='input-group-prepend'>
                    <span className='input-group-text text-black'>{t('on')}</span>
                  </div>
                  <input onFocus={(e) => e.target.select()} className='form-control text-center fs-20' type='number'
                         value={state.checkSharePersons} min={1} max={9} autoFocus={true}
                         placeholder={t('components.menu.personsCount')}
                         onChange={(e) => setDivision(e.target.value)}/>
                  <div className='input-group-append'>
                    <span className='input-group-text text-black'>
                      {state.checkSharePersons > 4 ? t('components.menu.manyPersons') :
                        (parseInt(state.checkSharePersons) === 1 ?
                          t('components.menu.onePerson') : t('components.menu.manyPersons2'))}
                    </span>
                  </div>
                </div>
                <hr/>
                { state.checkSharePersons > 1 ?
                  <>
                    {[...Array(parseInt(state.checkSharePersons))].map((_, i) =>
                      <div className='input-group mt-3' key={i}>
                        <div className='input-group-prepend'>
                          <span className='input-group-text text-black'>{t('components.menu.person')} {i+1}</span>
                        </div>
                        <input className='form-control text-center fs-20' type='number'
                               value={state.dividedPayChecks[i].amount} min={1}
                               placeholder={t('sum')}
                               onChange={(e) => setPersonCheckAmount(i, e.target.value)}/>
                        <div className='input-group-append'>
                          <span className='input-group-text text-black'>₴</span>
                        </div>
                      </div>)}
                  </>
                :
                  <>
                    { parseInt(state.checkSharePersons) === 1 &&
                      <Button className='btn btn-success w-100 mt-3'
                              onClick={() => {
                                setState({...state, payAlone: true});
                                setCheckShare(false)
                              }}
                      >
                        {t('components.menu.payAlone')}
                      </Button>}
                  </>}
                <Button className='btn btn-danger w-100 mt-3' onClick={() => setCheckShare(false)}>
                  {t('components.menu.cancelChanges')}
                </Button>
                { parseInt(state.checkSharePersons) !== 1 &&
                  <>
                    { calculateAmount(tablePayChecks(store.restaurants[slug].table)) === calculateAmount(state.dividedPayChecks) ?
                      <Button className='btn btn-success w-100 mt-3' onClick={divideCheck}
                              disabled={disabledCheckShare}
                      >
                        {t('components.menu.divideBill')}
                      </Button>
                    :
                      <h4 className='text-danger mt-3 text-center'>
                        {t('components.menu.someToAdd')}{' '}
                        {(calculateAmount(tablePayChecks(store.restaurants[slug].table)) - calculateAmount(state.dividedPayChecks)).toFixed(2)}<small>₴</small>
                      </h4>}
                  </>}
              </>}
          </Modal.Body>
        </Modal>}

      {/*/!*Actions modal*!/*/}

      { !!store.restaurants[slug] && !!store.restaurants[slug].table && state.showInitialModal &&
        !store.restaurants[slug].table.is_terminal &&
        <Modal className="fade" show={state.showInitialModal}>
          <Modal.Header style={{justifyContent: 'center'}}>
            <Modal.Title>
              { !(store.restaurants[slug].allow_extra_menus &&
                !!store.restaurants[slug].extra_menus && store.restaurants[slug].extra_menus.length > 0) &&
                <>
                  { !!store.restaurants[slug].logo ?
                    <img src={store.restaurants[slug].logo}
                         style={{borderRadius: 10, height: 50}} className='mb-3'/>
                  :
                    <h3 className='text-black text-center'>{translateRecord(store.restaurants[slug], 'name')}</h3>}
                </>}
              <h3 className='mb-0 text-center'
                  onClick={!!storeAuth.auth.restaurant &&
                    store.restaurants[slug].id === storeAuth.auth.restaurant.id ? getTables : null}
              >
                {state.selectedTable.name || store.restaurants[slug].table.name}
              </h3>
              { !!store.restaurants[slug].wifi &&
                <div className='d-flex align-items-center justify-content-center mt-2'>
                  <WiFi fill={!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : '#484645'} width={30} height={30}/>
                  <p className='mb-0 text-black d-inline ml-2'>{store.restaurants[slug].wifi}</p>
                </div>}
            </Modal.Title>
            <Button variant="" className="close"
              onClick={() => setState({...state, showInitialModal: false, showQRProve: false})}
            >
              <span>&times;</span>
            </Button>
          </Modal.Header>
          <Modal.Body style={{height: 'calc(100vh - 100px)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            <div style={{maxHeight: '80vh', overflowY: 'auto', width: '100%'}} className="text-center">
              { state.showQRProve ?
                <>
                  <h4 className='text-black text-center'>{t('components.menu.repeatQR')}</h4>
                  <QRcodeReader action={state.qrProveFunction} history={props.history}
                                 checking={[`${window.location.protocol}//${window.location.host}/restaurants/${slug}/menu?${store.restaurants[slug].table.id}`,
                      `${window.location.protocol}//${window.location.host}/r/${slug}/menu?${store.restaurants[slug].table.id}`]}
                                 restautrantSlug={slug} tableId={store.restaurants[slug].table.id}
                  />
                  { !state.detectedLocation.lat &&
                    <>
                      <h4 className='text-center'>або</h4>
                      <Button className='btn-outline-primary w-100' onClick={grantGeoLocation}>
                        {t('components.menu.giveGeoAccess')}
                      </Button>
                    </>}
                </>
              :
                <>
                  { state.showInitExtraRests && store.restaurants[slug].allow_extra_menus &&
                    !!store.restaurants[slug].extra_menus && store.restaurants[slug].extra_menus.length > 0 ?
                    <div className='text-center'>
                      <h3>{t('components.menu.chooseRestaurant')}</h3>
                      <p>{t('components.menu.orderCanBeDivided')} {store.restaurants[slug].extra_menus.length + 1} {t('components.menu.atSameTime')}</p>
                      <div className={`order-dish ml-1 extra-menu active-order`}
                           style={{boxShadow: '0px 3px 10px 0px rgba(29, 10, 3, 0.08)'}}
                           onClick={() => setState({...state, showInitialModal: false, showQRProve: false, selectedExtraMenu: {}, showInitExtraRests: false})}
                      >
                        { !!store.restaurants[slug].logo ?
                          <img src={store.restaurants[slug].logo}
                               style={{filter: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? "invert(100%) brightness(1000%)" : ''}}/>
                          :
                          <h4 className='mb-0'>{translateRecord(store.restaurants[slug], 'name')}</h4>}
                        <p className='text-black fs-20 mb-0'>{translateRecord(store.restaurants[slug], 'extra_description')}</p>
                        <p className='fs-18 mb-0' style={{color: '#FC9564'}}>
                          <i className='fa fa-clock-o mr-1'/>
                          {working_time(store.restaurants[slug])}
                        </p>
                      </div>
                      { store.restaurants[slug].extra_menus.map((r, i) =>
                        <div key={i} className={`order-dish ml-1 extra-menu active-order`}
                             style={{boxShadow: '0px 3px 10px 0px rgba(29, 10, 3, 0.08)'}}
                             onClick={() => getExtraMenu(r)}
                        >
                          { !!r.logo ?
                            <img src={r.logo} style={{filter: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? "invert(100%) brightness(1000%)" : ''}}/>
                          :
                            <h4 className='mb-0'>{translateRecord(r, 'name')}</h4>}
                          <p className='text-black fs-20 mb-0'>{translateRecord(r, 'extra_description')}</p>
                          <p className='fs-18 mb-0' style={{color: '#FC9564'}}>
                            <i className='fa fa-clock-o mr-1'/>
                            {working_time(r)}
                          </p>
                        </div>)}
                    </div>
                  :
                    <>
                      <Button className='btn btn-lg btn-primary w-100 mb-3 d-flex align-items-center justify-content-center'
                              style={{position: 'relative'}}
                              onClick={() => setState({...state, showInitialModal: false})}
                      >
                        <span className='emoji mr-2 fs-32' role="img" aria-label='label'>
                          {String.fromCodePoint('0x1F4D6')}
                        </span>
                        <b>{t('menu')}{hasQRorders() && <>, {t('order').toLowerCase()}</>}</b>
                      </Button>
                      { store.restaurants[slug].table.room.allow_waiter_request &&
                        <Button className='btn btn-lg btn-secondary w-100 mb-3 d-flex align-items-center justify-content-center'
                                onClick={() => toggleQRprove(() => approveOrder('waiterRequestModal', true))}
                        >
                          <span className='emoji mr-2 fs-32' role="img" aria-label='label'>
                            {String.fromCodePoint('0x1F6CE')}
                          </span>
                          <span>{t('components.menu.requestWaiter')}</span>
                        </Button>}
                      { (!store.restaurants[slug].table.room.ask_after_pay_method || !!store.restaurants[slug].table.pay_check) &&
                        <Button className='btn btn-lg btn-secondary w-100 mb-3 d-flex align-items-center justify-content-center position-relative'
                                onClick={payBillFunction}
                        >
                          <span className='emoji mr-2 fs-32' role="img" aria-label='label'>
                            {String.fromCodePoint('0x1F9FE')}
                          </span>
                          <span>{t('components.menu.payBill')}</span>
                          { !!store.restaurants[slug].table.pay_check &&
                            <h6 className='unpaid-paychecks text-white'>{payCheckAmount().toFixed(2)}<small>₴</small></h6>}
                        </Button>}
                      { !!store.restaurants[slug].tips_url &&
                        <a href={store.restaurants[slug].tips_url} target='_blank' style={{border: 'none'}}
                           className='btn btn-lg btn-secondary w-100 mb-3 d-flex align-items-center justify-content-center'
                        >
                          <span className='emoji mr-2 fs-32' role="img" aria-label='label'>
                            {String.fromCodePoint('0x1FAD9')}
                          </span>
                          <span>{t('components.menu.leaveTips')}</span>
                        </a>}
                      { !!store.restaurants[slug].services &&
                        <>
                          { Object.values(store.restaurants[slug].services)
                              .filter((s) => s.kind === 'qr' || s.kind === 'both').map((s,i) =>
                            <Button key={i}
                              onClick={() => toggleQRprove(() => approveOrder('selectedService', s.id))}
                              className='btn btn-lg btn-secondary w-100 mb-3 d-flex align-items-center justify-content-center'
                            >
                              <span className='emoji mr-2 fs-32' role="img" aria-label='label'>
                                {String.fromCodePoint(s.emoji)}
                              </span>
                              <span>{translateRecord(s, 'name')}</span>
                            </Button>)}
                        </>}
                      { !!store.restaurants[slug].order_taxi &&
                        <Link to={{pathname: '/taxi', state: { restaurant: store.restaurants[slug] }}}
                              style={{border: 'none'}}
                              className='btn btn-lg btn-secondary w-100 mb-3 d-flex align-items-center justify-content-center'
                        >
                          <span className='emoji mr-2 fs-32' role="img" aria-label='label'>
                            {String.fromCodePoint('0x1F695')}
                          </span>
                          <span>{t('components.menu.taxi')}</span>
                        </Link>}
                      <Link to={`/r/${slug}`} style={{border: 'none'}}
                            className='btn btn-lg btn-secondary w-100 mb-3 d-flex align-items-center justify-content-center'
                      >
                        <span className='emoji mr-2 fs-32' role="img" aria-label='label'>
                            {String.fromCodePoint('0x1F5BC')}
                          </span>
                        <span>{t('components.menu.photoReviews')}</span>
                      </Link>
                    </>}
                </>}
            </div>
          </Modal.Body>
        </Modal>}

      {/*Select table modal*/}

      <Modal className="fade" show={state.showTableSelectModal}>
        <Modal.Header>
          <Modal.Title className='text-black'>{t('components.menu.selectTable')}</Modal.Title>
          <Button variant="" className="close" onClick={() => setState({...state, showTableSelectModal: false})}>
            <span>&times;</span>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div className='form-group'>
            <Select options={Object.values(state.tables).map((s) =>
              {return ({ value: s.id, label: `${state.rooms[s.room_id].name}: ${s.name}`, name: s.name})})}
                    onChange={(s) => setTable(s)}
                    placeholder={t('components.menu.selectTable')}
                    value={state.selectedTable.id ? state.selectedTable : null}
                    style={{lineHeight: 40, color: '#7e7e7e', paddingLeft: 15}}
            />
          </div>
        </Modal.Body>
      </Modal>

      {/*Service modal*/}

      { !!state.selectedService &&
        <Modal className="fade" show={!!state.selectedService}>
          <Modal.Header>
            <Modal.Title className='text-black'>
              <h4>{translateRecord(store.restaurants[slug].services[state.selectedService], 'name')}</h4>
            </Modal.Title>
            <Button variant="" className="close" onClick={() => setState({...state, selectedService: 0})}>
              <span>&times;</span>
            </Button>
          </Modal.Header>
          <Modal.Body className='text-center'>
            { !!store.restaurants[slug].services[state.selectedService].price &&
              <h6>{store.restaurants[slug].services[state.selectedService].price}<small>₴</small></h6>}
            <p>{store.restaurants[slug].services[state.selectedService].description}</p>
            { store.restaurants[slug].services[state.selectedService].service_action === 'notify' &&
              <textarea rows={4} value={state.serviceMessage} className='form-control mb-4'
                        placeholder={t('components.menu.orderDescription')}
                        onChange={(e) => setState({...state, serviceMessage: e.target.value})}/>}
          </Modal.Body>
          { store.restaurants[slug].services[state.selectedService].service_action !== 'no_action' &&
            <Modal.Footer>
              { store.restaurants[slug].services[state.selectedService].service_action === 'phone' ?
                <a href={`tel:+${store.restaurants[slug].services[state.selectedService].phone}`}
                   className='btn btn-warning w-100' style={{border: 'none'}}
                >
                  <h4 className='text-full-black mb-0'>{t('call')}</h4>
                </a>
              :
                <Button className='btn btn-warning w-100' onClick={requestService}>
                  <h4 className='text-full-black mb-0'>{t('order')}</h4>
                </Button>}
            </Modal.Footer>}
        </Modal>}

      {state.showGetLocation && <GetLocation onLocationChange={handleLocationChange}/>}
    </div>
  );
};

export default MenuIndex;
